export default "__VITE_ASSET__5db96119__"